import { Box, Divider, Grid} from "@mui/material";
import { MenusProps } from "../"
import { escurecerCor } from "../../../../helpers/manipulacaoCores"
import { colors } from "../../bannerColors"
import TemplateOpcoes from "../../Templates/TemplateOpcoes"
import AddIcon from '@mui/icons-material/Add';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import { useNavigate } from "react-router-dom";
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import {useModalStateContext} from "../../../../contexts/ModalStateContext";
import { usePermission } from "../../../PermissionGuard";

export default function ReceituarioMenu({ type }: MenusProps) {

    const navigate = useNavigate();

    const color = colors[type] || "#1E2E6B"
    const textColor = escurecerCor(color)

    const handleRedirect = (path: string) => {
        navigate(`/receituario-agronomico/${path}`)
    }

    const { handleToggleModal } = useModalStateContext();

    return (
        <Box>
            <Grid container spacing={2}>

                <TemplateDashboardComOpcoes
                    {...{ type }}
                    color={textColor}
                    items={[]}
                />

                <Divider orientation="vertical" sx={{ border: '1px solid', borderColor: 'divider', }} flexItem />

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Agrônomo"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir agronômo",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => {},
                                disabled: !usePermission('receituario.incluir-agronomo') && true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("agronomo/listar-todos"),
                                disabled: !usePermission('receituario.listar-agronomos')
                            }
                        ]}
                    />

                    <TemplateOpcoes
                        title="Culturas"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir Cultura",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => handleToggleModal(
                                    "receituarioAgronomico",
                                    "incluirCultura",
                                    true
                                ),
                                disabled: !usePermission('receituario.incluir-cultura')
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("culturas/listar-todos"),
                                disabled: !usePermission('receituario.listar-culturas')
                            }
                        ]}
                    />
                </Grid>


                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">

                    <TemplateOpcoes
                        title="Pragas"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir Praga",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => handleToggleModal(
                                    "receituarioAgronomico",
                                    "incluirPragas",
                                    true
                                ),
                                disabled: !usePermission("receituario.incluir-praga")
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("pragas/listar-todos"),
                                disabled: !usePermission("receituario.listar-pragas")
                            }
                        ]}
                    />

                    <TemplateOpcoes
                        title="Ingredientes ativos"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir ingrediente ativo",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => handleToggleModal(
                                    "receituarioAgronomico",
                                    "incluirIngredientesAtivos",
                                    true
                                ),
                                disabled: !usePermission("receituario.incluir-ingrediente-ativo")
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("ingredientes-ativos/listar-todos"),
                                disabled: !usePermission("receituario.listar-ingredientes-ativos")
                            }
                        ]}
                    />
                </Grid>

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Agrotóxicos"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir agrotóxicos",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => handleToggleModal(
                                    "receituarioAgronomico",
                                    "IncluirAgrotoxico",
                                    true
                                ),
                                disabled: !usePermission("receituario.incluir-agrotoxico")
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("agrotóxicos/listar-todos"),
                                disabled: !usePermission("receituario.listar-agrotoxicos")
                            }
                        ]}
                    />
                    <TemplateOpcoes
                        title="Prescrições"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir prescrições",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => handleToggleModal(
                                    "receituarioAgronomico",
                                    "incluirPrescricoes",
                                    true
                                ),
                                disabled: !usePermission('receituario.incluir-prescricao')
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("prescricoes/listar-todos"),
                                disabled: !usePermission("receituario.listar-prescricoes")
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

